module.exports = fox._r("css/slick/fonts/slick.woff", __webpack_public_path__ + "_/_/_/main/css/slick/fonts/hqgf7TV.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/css/slick/fonts/slick.woff
// module id = 134
// module chunks = 4